/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Range, getTrackBackground } from 'react-range';
import type { RangeInputType } from './types';

const STEP = 1;
const MIN = 1;
const DEFAULT_MAX = 45;
const EXTENDED_MAX = 27;

export const RangeInput: React.FC<RangeInputType> = ({
  value,
  onChange,
  isExtendedRange = false,
}) => {
  const maxValue = isExtendedRange ? EXTENDED_MAX : DEFAULT_MAX;
  const handleChange = (v: number[]) => {
    onChange(v);
  };

  return (
    <div
      className="range"
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        width: 'inherit',
      }}
    >
      <Range
        values={value}
        step={STEP}
        min={MIN}
        max={maxValue}
        rtl={false}
        onChange={(v: number[]) => handleChange(v)}
        renderTrack={({ props, children }) => (
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            className="range__track"
            style={{
              ...props.style,
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              height: '5px',
              background: getTrackBackground({
                values: value,
                colors: ['#2563EB', '#DBEAFE'],
                min: MIN,
                max: maxValue,
                rtl: false,
              }),
              borderRadius: '4px',
              position: 'relative',
              paddingRight: '3px',
              transition: 'background 0.3s ease',
            }}
          >
            <div
              ref={props.ref}
              className="range__track-ch"
              style={{
                width: '100%',
                height: '100%',
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props }) => (
          <div
            {...props}
            className={
              (value[0] === MIN && 'range__thumb-first') ||
              (value[0] === maxValue && 'range__thumb-last')
            }
            style={{
              ...props.style,
              height: '14px',
              width: '14px',
              borderRadius: '50px',
              outlineStyle: 'solid',
              outlineColor: '#1D4ED8',
              outlineWidth: '2px',
              backgroundColor: '#FFF',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: '0px 2px 6px #AAA',
              transition: 'transform 0.2ms ease',
            }}
          />
        )}
      />
    </div>
  );
};
